package gr.tech.pdfgenerator.infrastructure.pdf

import gr.tech.pdfgenerator.util.CONSTANTS
import org.w3c.files.Blob
import org.w3c.files.FileReader

fun PdfAsBase64(blob: Blob) {
    // For example: convert to Base64
    val reader = FileReader()
    reader.onloadend = {
        val base64Data = reader.result as String
        console.log("Base64 PDF:", base64Data)
    }
    reader.readAsDataURL(blob)
}

fun parsePDFType(type: Int): String {
    return when (type) {
        CONSTANTS.PROJECT_TYPES.MSA -> "MSA"
        CONSTANTS.PROJECT_TYPES.LIGHTING_PROPOSAL -> "Light Proposal"
        CONSTANTS.PROJECT_TYPES.TIER_THREE -> "Tier Three"
        else -> "NA"
    }
}
